import get from 'lodash/get';

import { TransferAppState } from '@wetransfer/ad-sdk';

import { isDirectOrTestLink } from './router-helper';

/**
 * Provides a way to override the language and geo on wallpaper links:
 *
 *   wetransfer.com/wallpaper/1234   (direct link)
 *   wetransfer.com/?ad_id=1234      (test link)
 *
 * Possible parameters (wp stands for wallpaper):
 *
 *   ? wp_language=nl & wp_country=be
 *
 * These parameters shouldn't work on any other link, such as:
 *
 *   wetransfer.com
 *
 * The goal of these overrides is to match parameters that also exist on
 * AdPreview:
 *
 *   adpreview.wetransfer.com/?name=creator/demo&language=nl&country=be
 *
 * They will be used to share direct wallpaper links with sales clients,
 * without the need for those clients to change their browser language or go
 * on a VPN to test all versions of a wallpaper.
 */

export const getGeo = (
  session: Partial<TransferAppState['session']>,
  route: TransferAppState['route']
): {
  region?: {
    [key: string]: string;
  };
  country: string;
} => {
  let geo = session.region;

  if (isDirectOrTestLink(route)) {
    geo = {
      ...session.region,
      country: get(route, 'query.wp_country', get(session, 'region.country')),
    };
  }

  return geo;
};

export const getLanguage = (
  session: Partial<TransferAppState['session']>,
  route: TransferAppState['route']
): string => {
  let language = session.language;

  if (isDirectOrTestLink(route)) {
    language = get(route, 'query.wp_language', session.language);
  }

  return language;
};
